import { render, staticRenderFns } from "./UnitDeleteModal.vue?vue&type=template&id=27bfc04d&scoped=true&"
import script from "./UnitDeleteModal.vue?vue&type=script&lang=js&"
export * from "./UnitDeleteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27bfc04d",
  null
  
)

export default component.exports